import React from "react";

import axios from "axios";

import "./Navbar.scss";

export default function Navbar({
  inputValue,
  setInputValue,
  setUserData,
}) {
  // const [inputValue, setInputValue] = useState("");
  // const [userData, setUserData] = useState(null);

  const onSubmit = async e => {
    e.preventDefault();

    // const response = await axios.get(apiUrl);
    const response = await axios.get(
      `https://apiofopgg.herokuapp.com/user-data/${inputValue}`
    );

    // console.log(response.data);

    setUserData(response.data);
    setInputValue("");
  };

  const onChange = e => {
    setInputValue(e.target.value);
  };

  return (
    <nav className="navbar">
      <div className="navbar__logo">OP.GG</div>

      <form className="search" onSubmit={onSubmit}>
        <input
          onChange={onChange}
          value={inputValue}
          type="text"
          className="search__input"
          placeholder="Search a Summoner"
        />
        <button type="submit" className="search__button">
          <i className="fas fa-search"></i>
        </button>
        <input className="search__gg" type="submit" value=".GG" />
      </form>

      <div className="auth">
        <span className="auth__name">barmaley</span>
        <div className="auth__letter">B</div>
      </div>
    </nav>
  );
}
